import ApplicationController from './application_controller'

export default class extends ApplicationController {

	static targets = [
		'input',
	]

	static values = {
		'stepSize': Number
	}

	connect() {
		this.stepSize = this.getIntegerOrDefault(this.stepSizeValue, 5)
		if (this.stepSize == 0) this.stepSize = 5
	}

	increment(event) {
		const currentStringValue = this.inputTarget.value
		const currentValue = this.getIntegerOrDefault(currentStringValue, 30)
		const newValue = currentValue + this.stepSize
		this.inputTarget.value = newValue
	}

	decrement(event) {
		const currentStringValue = this.inputTarget.value
		const currentValue = this.getIntegerOrDefault(currentStringValue, 30)
		const newValue = currentValue - this.stepSize
		this.inputTarget.value = newValue
	}

	getIntegerOrDefault(stringValue, defaultValue) {
		let intValue = parseInt(stringValue)
		if (Number.isNaN(intValue)) intValue = defaultValue
		return intValue
	}
}

